import React from "react";

import { ErrorHandler } from "../errorHandler";

export const Page: React.FC<{ element: React.ReactNode }> = ({ element }) => {
  return <ErrorHandler>{element}</ErrorHandler>;
};
